module.exports = __webpack_public_path__ + "static/media/sell-product2.9627b997.png";